import React, { FunctionComponent, InputHTMLAttributes } from 'react';
import { Checkbox, AnalyticsProps } from '@inplayer-org/inplayer-ui';

interface OwnProps {
  label: string;
  name: string;
  id: string;
  checked: boolean;
  inlineLabel?: boolean;
  disabled?: boolean;
  onCheck: (e: any) => any;
}

type Props = InputHTMLAttributes<HTMLSelectElement> & OwnProps & AnalyticsProps;

const CheckboxField: FunctionComponent<Props> = ({
  label,
  name,
  id,
  checked,
  onCheck,
  disabled,
  tag = '',
  ...rest
}) => {
  return (
    <Checkbox
      tag={tag}
      label={label}
      name={name}
      id={id}
      checked={checked}
      {...rest}
      onChange={onCheck}
      disabled={disabled}
    />
  );
};

export default CheckboxField;
